import { SVGProps } from "react";

export function UserFill(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 0C18.6217 0 20.6566 0.842854 22.1569 2.34315C23.6571 3.84344 24.5 5.87827 24.5 8C24.5 10.1217 23.6571 12.1566 22.1569 13.6569C20.6566 15.1571 18.6217 16 16.5 16C14.3783 16 12.3434 15.1571 10.8431 13.6569C9.34285 12.1566 8.5 10.1217 8.5 8C8.5 5.87827 9.34285 3.84344 10.8431 2.34315C12.3434 0.842854 14.3783 0 16.5 0ZM16.5 20C25.34 20 32.5 23.58 32.5 28V32H0.5V28C0.5 23.58 7.66 20 16.5 20Z"
        fill="currentColor"
      />
    </svg>
  );
}
